<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/parent' }">
        <app-i18n code="entities.parent.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.parent.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.parent.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.parent.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.parent.new.title" v-if="!isEditing"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :disabled="true" v-model="model[fields.id.name]"/>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.gender.label"
          :prop="fields.gender.name"
          :required="fields.gender.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.gender.name]" ref="focus" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.children.label"
          :prop="fields.children.name"
          :required="fields.children.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-many-input
              :fetchFn="fields.children.fetchFn"
              v-model="model[fields.children.name]"
            ></app-autocomplete-many-input>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.country.label"
          :prop="fields.country.name"
          :required="fields.country.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.country.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.email.label"
          :prop="fields.email.name"
          :required="fields.email.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.email.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.role.label"
          :prop="fields.role.name"
          :required="fields.role.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.role.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.birthdate.label"
          :prop="fields.birthdate.name"
          :required="fields.birthdate.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.birthdate.name]" />
          </el-col>
        </el-form-item>

        <el-form-item>
          <div class="form-buttons">
            <el-button
              :disabled="saveLoading"
              @click="doSubmit"
              icon="el-icon-fa-floppy-o"
              type="primary"
            >
              <app-i18n code="common.save"></app-i18n>
            </el-button>

            <!-- <el-button :disabled="saveLoading" @click="doReset" icon="el-icon-fa-undo">
              <app-i18n code="common.reset"></app-i18n>
            </el-button> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { ParentModel } from '@modules/parent/parent-model';

export default {
  name: 'app-parent-form-page',

  props: ['id'],

  data() {
    return {
      model: null,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'parent/form/record',
      findLoading: 'parent/form/findLoading',
      saveLoading: 'parent/form/saveLoading',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    isEditing() {
      return !!this.id;
    },

    rules() {
      const { formSchema } = this;
      return formSchema.rules();
    },
    
    formSchema() {
      const { fields } = this;
      return new FormSchema([
        fields.id,
        fields.gender,
        fields.children,
        fields.country,
        fields.email,
        fields.role,
        fields.birthdate,
      ]);
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new ParentModel({ dateFormat, timeFormat }).fields();
    },
  },

  async created() {
    const { formSchema } = this;

    if (this.isEditing) {
      await this.doFind(this.id);
    } else {
      await this.doNew();
    }

    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doFind: 'parent/form/doFind',
      doNew: 'parent/form/doNew',
      doUpdate: 'parent/form/doUpdate',
      doCreate: 'parent/form/doCreate',
    }),

    doReset() {
      const { formSchema } = this;
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      const { formSchema } = this;
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
        });
      } else {
        return this.doCreate(values);
      }
    },
  },
};
</script>

<style>
</style>
